/* eslint-disable jsx-a11y/no-autofocus */
import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import HiddenInput from '../components/HiddenInput';
import LogoFW from '../components/LogoFW';
import { ProductInfoPage } from '../components/ProductInfoPage';
import { ProductNotFound } from '../components/ProductNotFound';
import RightMenu from '../components/RightMenu';
import WelcomePage from '../components/WelcomePage';
import { ADImageDelay, HideProductInfoDelay } from '../config';
import styles from '../style/style.scss';

interface AdvertisementAPI {
  id: number;
  content_type: 'Image' | 'Video';
  url: string;
  next: number;
}

export interface ProductAPI {
  ean_code: string;
  name: string;
  url: string;
  price: string;
}

function useQuery() {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
}

function AdsScene() {
  const adsList = useRef<AdvertisementAPI[]>([]);
  const selectedAd = useRef<null | AdvertisementAPI>(null);
  const delay = useRef(ADImageDelay);
  const videoRef = useRef<HTMLVideoElement | null>(null);

  const [abc, setTriggerRender] = useState(0);
  const triggerRender = () => {
    setTriggerRender(Math.random());
  };

  const loadAdsList = () => {
    console.log('Load new ads list');
    fetch('/api/v1/advertisements/')
      .then((r) => r.json())
      .then((data) => {
        const d = data as AdvertisementAPI[];
        // window.test = d;
        adsList.current = d;
        if (selectedAd.current == null) {
          const [fistad] = d;
          selectedAd.current = fistad;
          triggerRender();
        }
        console.log(data);
      });
  };

  const getNextAd = () => {
    if (selectedAd.current != null) {
      const sAd = selectedAd.current;
      const nextadd = adsList.current.find((e) => e.id === sAd.next);
      let isNewAdLoop = false;
      if (nextadd) {
        selectedAd.current = nextadd;
        isNewAdLoop = sAd.id >= nextadd?.id;
      } else {
        const [fistad] = adsList.current;
        selectedAd.current = fistad;
        isNewAdLoop = true;
      }
      triggerRender();
      if (isNewAdLoop) {
        loadAdsList();
      }
      // set correct video duration
      const loop = setInterval(() => {
        const dur = videoRef.current?.duration;
        if (dur) {
          delay.current = Math.ceil(dur);
          videoRef.current?.play();
          clearInterval(loop);
        }
      }, 100);
    }
  };

  useEffect(() => {
    loadAdsList();
    const loop = setInterval(() => {
      console.log(`Next ad in ${delay.current}sec`);
      delay.current -= 1;
      if (delay.current === 0) {
        delay.current = ADImageDelay;
        getNextAd();
      }
    }, 1000);
    return () => clearInterval(loop);
  }, []);

  console.log('render');
  if (selectedAd.current) {
    const thisAd = selectedAd.current;
    const isImage = thisAd.content_type === 'Image';

    return (
      <div className={styles.advertisement}>
        {isImage && (
          <div className={styles.image_ad}>
            <img src={thisAd.url} alt={`ad_${thisAd.id}`} />
          </div>
        )}
        {!isImage && (
          <div className={styles.video_ad}>
            <video ref={videoRef} autoPlay muted src={thisAd.url}>
              <source src={thisAd.url} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        )}
      </div>
    );
  }
  return <div>Ładowanie reklam...</div>;
}

// export function ShowProduct({ productInfo }: { productInfo: ProductAPI }) {
//   return <div className={styles.productpreview} style={{ backgroundImage: `url("${productInfo.url}")` }} />;
// }

function AppPage() {
  const [eanCode, setEanCode] = useState<string | null>(null);
  const navigate = useNavigate();
  let query = useQuery();

  useEffect(() => {
    if (eanCode) {
      const t = setTimeout(() => {
        setEanCode(null);
      }, HideProductInfoDelay * 1000);
      return () => clearTimeout(t);
    }
    return;
  }, [eanCode]);

  useEffect(() => {
    setEanCode(query.get('product'));
  }, []);

  const getProductEanCallback = (ean_code: string) => {
    setEanCode(null);
    setTimeout(() => setEanCode(ean_code), 1);
  };

  return (
    <div>
      <HiddenInput getProductEanCallback={getProductEanCallback} />
      {eanCode && (
        <div className={styles.productpreview}>
          <ProductInfoPage ean_code={eanCode} showPollButton={true} eventName="scan" />
        </div>
      )}
      <AdsScene />
      {!eanCode && (
        <div
          className={styles.clickLayer}
          onClick={() => {
            navigate('/poll');
          }}
          role="button"
          aria-hidden="true"
        />
      )}
    </div>
  );
}

export default AppPage;
